<template>
  <span id="add-bill-of-lading">
    <bill-of-lading-detail-dialog ref="bolDetailDialog" :currentRow="bolAdded" :show-icon-grid="false"/>
    <el-button id="btn-add-bill-of-lading" type="success" plain @click="handleOpenDialog" class="margin-r-10"
               size="mini">{{ $t('customerService.billOfLading.addBol') }}</el-button>
    <el-dialog
      width="60%"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      :title="$t('customerService.billOfLading.addBol')"
      class="dialog-with-cols"
    >
      <el-form :model="addForm" :rules="addFormRules" label-position="top" ref="addForm" size="mini">
        <el-row>
          <el-col :md="8" :sm="12" :xs="12" class="form-vertical-item">
            <el-form-item :label="$t('customerService.billOfLading.date')" prop="date" ref="date" class="inline-input">
              <el-date-picker
                class="el-dropdown-new drop-sp date-dob"
                size="mini"
                v-model="addForm.date"
                format="MM/dd/yyyy"
                :clearable="false"
                type="date"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8" class="form-vertical-item">
            <el-form-item :label="$t('customerService.billOfLading.paymentTerm')" prop="paymentTerm" ref="paymentTerm">
              <el-select v-model="addForm.paymentTerm">
                <el-option
                  v-for="option in paymentTerms"
                  :key="option.value"
                  :label="option.label"
                  :value="option.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8" class="form-vertical-item">
            <el-form-item :label="$t('customerService.billOfLading.subAccount')">
              <el-select v-model="addForm.subAccount" @change="handleSubAccountChange">
                <el-option
                  v-for="item in subAccountOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :md="8" :sm="12" :xs="12" class="form-vertical-item">
            <el-form-item :label="$t('customerService.billOfLading.consignee')" prop="consignee"
                          ref="consignee"
                          class="inline-input">
              <autocomplete
                :model.sync="addForm.consignee"
                labelFieldLastWithDash="number"
                popperAppendToBody
                :url="urlConsignee"
                labelField="name"
                valueField="id"
                ref="consigneeAutocomplete"
                id="consigneeAutocomplete"
                :selectAction="handleConsigneeChange"
              />
            </el-form-item>
          </el-col>
          <el-col :md="8" :sm="12" :xs="12" class="form-vertical-item" v-if="!addForm.subAccount">
            <el-form-item :label="$t('customerService.billOfLading.billTo')" prop="billTo"
                          ref="billTo"
                          class="inline-input">
              <autocomplete
                :model.sync="addForm.billTo"
                labelFieldLastWithDash="number"
                popperAppendToBody
                :url="urlBillTo"
                labelField="name"
                valueField="id"
                ref="billToAutocomplete"
                id="billToAutocomplete"
                class="inline-input"
              />
            </el-form-item>
          </el-col>
          <el-col :md="8" :sm="12" :xs="12" class="form-vertical-item" v-if="!addForm.subAccount">
            <el-form-item :label="$t('customerService.billOfLading.deliverTo')" prop="deliverTo"
                          ref="deliverTo"
                          class="inline-input">
              <autocomplete
                :model.sync="addForm.deliverTo"
                labelFieldLastWithDash="number"
                popperAppendToBody
                :url="urlConsignee"
                labelField="name"
                valueField="id"
                ref="deliverToAutocomplete"
                id="deliverToAutocomplete"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :md="8" :sm="12" :xs="12" class="form-vertical-item">
            <el-form-item :label="$t('customerService.billOfLading.loadNumber')">
              <el-input
                v-model="addForm.loadNumber"
                v-alphanumeric-validation
                maxlength="25"
                clearable
                class="inline-input"
                id="loadNumberInput"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <div id="add-bill-of-lading-dialog-footer" slot="footer"
           class="dialog-footer form-vertical-item flex-reverse-direction">
      <el-button type="primary" id="form-save-button" @click="handleSave()"
                 size="mini">{{ $t('customerService.billOfLading.addBol') }}</el-button>
      <el-button id="form-refresh-button" @click="resetForm()" size="mini">{{ $t('common.clear') }}</el-button>
    </div>
    </el-dialog>
  </span>
</template>

<script>
import { Message } from 'element-ui';
import apiConstants from '@/utils/apiConstants';
import constants from '@/utils/constants';
import BillOfLadingDetailDialog from '@/views/customerCenter/billOfLading/components/BillOfLadingDetailDialog';
import Autocomplete from '@/components/Autocomplete/index';

export default {
  name: 'AddBillOfLading',
  components: {
    BillOfLadingDetailDialog,
    Autocomplete
  },
  computed: {
    urlBillTo:
      () => `${apiConstants.END_POINTS.ACCOUNTS.ALL_BY_TYPE.replace('{accountTypeId}', '0')}/1`,
    urlConsignee: () => apiConstants.END_POINTS.ACCOUNTS.CONSIGNEE,
    urlLoads: () => apiConstants.END_POINTS.LOADS.SEARCH,
    subAccountOptions:
      () => ([
        {
          value: constants.STATUS_BOOLEAN.no.value,
          label: constants.STATUS_BOOLEAN.no.label
        },
        {
          value: constants.STATUS_BOOLEAN.yes.value,
          label: constants.STATUS_BOOLEAN.yes.label
        }
      ]),
    paymentTerms: () => constants.SHIPMENT.PAYMENT_TERMS
  },
  data() {
    return {
      bolAdded: {},
      dialogVisible: false,
      editForm: {
        date: new Date(),
        billTo: null,
        consignee: null,
        deliverTo: null,
        subAccount: false,
        paymentTerm: null,
        loadNumber: null
      },
      editFormRules: {
        date: [
          {
            required: true,
            message: this.$t('customerService.billOfLading.error.dateRequired'),
            trigger: 'blur'
          }
        ],
        billTo: [
          {
            required: true,
            message: this.$t('customerService.billOfLading.error.billToAccountRequired'),
            trigger: 'submit'
          }
        ],
        consignee: [
          {
            required: true,
            message: this.$t('customerService.billOfLading.error.consigneeAccountRequired'),
            trigger: 'submit'
          }
        ],
        deliverTo: [
          {
            required: true,
            message: this.$t('customerService.billOfLading.error.deliverToAccountRequired'),
            trigger: 'submit'
          }
        ],
        paymentTerm: [
          {
            required: true,
            message: this.$t('customerService.billOfLading.error.paymentTermsRequired'),
            trigger: 'blur'
          }
        ]
      }
    };
  },
  methods: {
    handleSave() {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          Message.closeAll();
          const loading = this.$loading(constants.LOADING.DEFAULT_CONFIG);
          this.$store
            .dispatch('billOfLading/addBol', this.editForm)
            .then((response) => {
              this.$store.dispatch('billOfLading/search', {});
              this.$store.dispatch('billOfLading/getById', response.data)
                .then((newBolResponse) => {
                  this.$message.success(response.message);
                  this.bolAdded = newBolResponse;
                  this.dialogVisible = false;
                  loading.close();
                  if (this.$refs && this.$refs.bolDetailDialog) {
                    this.$nextTick(() => {
                      this.$refs.bolDetailDialog.handleOpenDialog();
                    });
                  }
                });
            });
        }
      });
    },
    handleOpenDialog() {
      this.dialogVisible = true;
      this.resetForm();
    },
    resetForm() {
      if (this.$refs && this.$refs.editForm) {
        this.$refs.editForm.resetFields();
      }
      this.editForm.subAccount = constants.STATUS_BOOLEAN.no.value;
      this.editForm.paymentTerms = null;
      this.editForm.date = new Date();
      this.editForm.loadNumber = null;
      this.clearAutocomplete();
    },
    clearAutocomplete() {
      this.editForm.billTo = null;
      this.editForm.consignee = null;
      this.editForm.deliverTo = null;
      if (this.$refs.billToAutocomplete) {
        this.$refs.billToAutocomplete.clearLocalModel();
      }
      if (this.$refs.consigneeAutocomplete) {
        this.$refs.consigneeAutocomplete.clearLocalModel();
      }
      if (this.$refs.deliverToAutocomplete) {
        this.$refs.deliverToAutocomplete.clearLocalModel();
      }
    },
    handleConsigneeChange() {
      if (this.editForm.subAccount) {
        this.editForm.billTo = this.editForm.consignee;
        this.editForm.deliverTo = this.editForm.consignee;
      }
    },
    handleSubAccountChange(subAccount) {
      if (subAccount) {
        this.editForm.billTo = this.editForm.consignee;
        this.editForm.deliverTo = this.editForm.consignee;
      } else {
        this.editForm.billTo = null;
        this.editForm.deliverTo = null;
        if (this.$refs.billToAutocomplete) {
          this.$refs.billToAutocomplete.clearLocalModel();
        }
        if (this.$refs.deliverToAutocomplete) {
          this.$refs.deliverToAutocomplete.clearLocalModel();
        }
      }
    }
  }
};
</script>

<style lang="scss">
#add-bill-of-lading {
  .el-date-editor {
    width: 100%;
  }
}
</style>
